import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import en from "./locales/en.json";

i18n.use(initReactI18next).init({
    resources: {
        en: en,
        de: de,
    },
    lng: navigator.language.split('-')[0] || "de",
    fallbackLng: "de",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;